import { useMutation, useQueryClient } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import {
  IBaseTransferDetails,
  IScanTrayPodTransferCancelPayload,
  ICustomApiError,
} from '../../../types';

import { TRANSFER_LIST_QUERY_KEY } from './useTransferListQuery';

const MUT_SCAN_TRAY_POD_TRANSFER_CANCEL =
  'scan-tray-pod-transfer-cancel-mutation';

interface IScanTrayPodTransferCancelMutationParam {
  onError?: (err: ICustomApiError) => void;
  onSuccess?: (details: IBaseTransferDetails) => void;
}

/**
 * Custom hook for scanning tray pod transfer cancellation.
 */
export const useScanTrayPodTransferCancelMutation = ({
  onError,
  onSuccess,
}: IScanTrayPodTransferCancelMutationParam): {
  isError: boolean;
  isPending: boolean;
  isSuccess: boolean;
  error: ICustomApiError | null;
  scanTrayPodTransferCancel: (
    payload: IScanTrayPodTransferCancelPayload
  ) => void;
  resetScanTrayPodTransferCancel: () => void;
  data?: IBaseTransferDetails;
} => {
  const queryClient = useQueryClient();
  const { isError, data, error, isPending, isSuccess, mutate, reset } =
    useMutation({
      mutationKey: [MUT_SCAN_TRAY_POD_TRANSFER_CANCEL],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.scanTrayPodTransferCancel,
      onError,
      onSuccess: (resData) => {
        queryClient.invalidateQueries({ queryKey: [TRANSFER_LIST_QUERY_KEY] });
        onSuccess?.(resData);
      },
    });

  return {
    data,
    error,
    isError,
    isPending,
    isSuccess,
    resetScanTrayPodTransferCancel: reset,
    scanTrayPodTransferCancel: mutate,
  };
};
